<section class="home-modulos" id="modulos">
  <div class="home-modulos__inner">
    <h2 class="home-modulos__title">Empieza por la base. Crece a tu ritmo.</h2>
    <p class="home-modulos__sub">
      La base trae el cumplimiento conectado desde el primer día. Sumas módulos
      solo cuando los necesitas, y los potencias con complementos.
    </p>

    @if (isLoading()) {
      <div class="home-modulos__state"><p>Cargando catálogo…</p></div>
    } @else {
      <!-- Incluido en la base -->
      @if (baseIncluded().length > 0) {
        <div class="base-card">
          <div class="base-card__head">
            <span class="base-card__label">Incluido en la base</span>
            <span class="base-card__hint">45 €/mes · operativos ilimitados</span>
          </div>
          <div class="base-card__items">
            @for (b of baseIncluded(); track b.label) {
              <span class="base-card__item">
                <app-hex-icon [color]="b.color" [size]="18" [height]="20" />
                {{ b.label }}
              </span>
            }
          </div>
          <div class="base-card__pills">
            <span class="base-card__pill base-card__pill--primary">
              Operativos ilimitados
            </span>
            <span class="base-card__pill">1 usuario completo incluido</span>
          </div>
        </div>
      }

      <!-- Módulos -->
      @if (modules().length > 0) {
        <div class="home-modulos__group">
          <h3 class="home-modulos__group-title">Módulos</h3>
          <span class="home-modulos__group-note">cada uno · funcionan por sí solos</span>
        </div>
        <div class="home-modulos__grid">
          @for (m of modules(); track m.title) {
            <article class="mod-card" [style.--mod-color]="m.color">
              <div class="mod-card__top">
                <app-hex-icon [color]="m.color" [size]="36" [height]="40" />
                <span class="mod-card__tag">+{{ m.price }} {{ m.unit }}</span>
              </div>
              <h3 class="mod-card__title">{{ m.title }}</h3>
              @if (m.desc) {
                <p class="mod-card__desc">{{ m.desc }}</p>
              }
            </article>
          }
        </div>
      }

      <!-- Complementos -->
      @if (complements().length > 0) {
        <div class="home-modulos__group home-modulos__group--tight">
          <h3 class="home-modulos__group-title">Complementos</h3>
        </div>
        <p class="home-modulos__group-sub">
          Potencian un módulo que ya tienes. No existen sin él.
        </p>
        <div class="comp-grid">
          @for (c of complements(); track c.title) {
            <div class="comp-card">
              <span class="comp-card__dot" [style.--comp-color]="c.color"></span>
              <div class="comp-card__body">
                <div class="comp-card__title">
                  {{ c.title }}
                  <span class="comp-card__price">+{{ c.price }} {{ c.unit }}</span>
                </div>
                @if (c.capacity) {
                  <div class="comp-card__capacity">{{ c.capacity }}</div>
                }
                @if (c.desc) {
                  <div class="comp-card__desc">{{ c.desc }}</div>
                }
              </div>
            </div>
          }
        </div>
      }

      <div class="home-modulos__cta">
        <a routerLink="/modulos" class="home-modulos__link">
          Ver todos los módulos
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
        </a>
      </div>
    }
  </div>
</section>
